import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_breadcrumb = _resolveComponent("base-breadcrumb");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("main", null, [_createVNode(_component_base_breadcrumb), _createVNode(_component_router_view)]);
}